import { render, staticRenderFns } from "./UpdateAccountNamePopup.vue?vue&type=template&id=503dd2c1&scoped=true"
import script from "./UpdateAccountNamePopup.vue?vue&type=script&lang=js"
export * from "./UpdateAccountNamePopup.vue?vue&type=script&lang=js"
import style0 from "./UpdateAccountNamePopup.vue?vue&type=style&index=0&id=503dd2c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503dd2c1",
  null
  
)

export default component.exports